/**
 * COLLAPSIBLES — методы для управления свёрнутыми/развёрнутыми секциями
 * редакторов (Описание программы / Комментарии к смете / Условия бронирования).
 *
 * Phase 5 sub-extract (Sprint 15 C.3 part 1, 2026-05-10).
 * Извлечено из public/js/app.js.
 *
 * Все три секции имеют идентичный pattern:
 *   • toggleX() — переключает класс `.expanded` + пишет state в localStorage
 *   • restoreXState() — восстанавливает состояние при загрузке (на DOMContentLoaded)
 *   • updateCollapsibleHeight() — пересчёт высоты при изменении содержимого
 *
 * Подключение из entry.js через `attachCollapsibles(ProfessionalQuoteCalculator)`.
 *
 * @module app/collapsibles
 */

'use strict';

export function attachCollapsibles(ClassRef) {
    Object.assign(ClassRef.prototype, {
        toggleProgramDescription() {
            const section = document.getElementById('program-description-section');
            const content = section.querySelector('.collapsible-content');
            const inner = section.querySelector('.collapsible-content-inner');
            const textarea = document.getElementById('program-description');

            section.classList.toggle('expanded');
            const isExpanded = section.classList.contains('expanded');

            // Динамически устанавливаем высоту на основе содержимого
            if (isExpanded) {
                // Инициализируем высоту textarea при раскрытии
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';

                // Устанавливаем высоту секции
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            } else {
                content.style.maxHeight = '0';
            }

            // Сохраняем состояние в localStorage
            localStorage.setItem('quoteCalc_programDescExpanded', isExpanded);
        },

        toggleQuoteComments() {
            const section = document.getElementById('quote-comments-section');
            const content = section.querySelector('.collapsible-content');
            const inner = section.querySelector('.collapsible-content-inner');
            const textarea = document.getElementById('quote-description');

            section.classList.toggle('expanded');
            const isExpanded = section.classList.contains('expanded');

            // Динамически устанавливаем высоту на основе содержимого
            if (isExpanded) {
                // Инициализируем высоту textarea при раскрытии
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';

                // Устанавливаем высоту секции
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            } else {
                content.style.maxHeight = '0';
            }

            // Сохраняем состояние в localStorage
            localStorage.setItem('quoteCalc_quoteCommentsExpanded', isExpanded);
        },

        toggleBookingTerms() {
            const section = document.getElementById('booking-terms-section');
            const content = section.querySelector('.collapsible-content');
            const inner = section.querySelector('.collapsible-content-inner');
            const textarea = document.getElementById('booking-terms');

            section.classList.toggle('expanded');
            const isExpanded = section.classList.contains('expanded');

            // Динамически устанавливаем высоту на основе содержимого
            if (isExpanded) {
                // Инициализируем высоту textarea при раскрытии
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';

                // Устанавливаем высоту секции
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            } else {
                content.style.maxHeight = '0';
            }

            // Сохраняем состояние в localStorage
            localStorage.setItem('quoteCalc_bookingTermsExpanded', isExpanded);
        },

        restoreProgramDescriptionState() {
            const section = document.getElementById('program-description-section');
            const content = section.querySelector('.collapsible-content');
            const inner = section.querySelector('.collapsible-content-inner');
            const textarea = document.getElementById('program-description');
            const savedState = localStorage.getItem('quoteCalc_programDescExpanded');

            // Инициализируем высоту textarea
            if (textarea.value) {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';
            }

            // По умолчанию свернут, разворачиваем только если было сохранено expanded состояние
            if (savedState === 'true') {
                section.classList.add('expanded');
                // Устанавливаем динамическую высоту
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            }
        },

        restoreQuoteCommentsState() {
            const section = document.getElementById('quote-comments-section');
            const content = section.querySelector('.collapsible-content');
            const inner = section.querySelector('.collapsible-content-inner');
            const textarea = document.getElementById('quote-description');
            const savedState = localStorage.getItem('quoteCalc_quoteCommentsExpanded');

            // Инициализируем высоту textarea
            if (textarea.value) {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';
            }

            // По умолчанию свернут
            if (savedState === 'true') {
                section.classList.add('expanded');
                // Устанавливаем динамическую высоту
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            }
        },

        restoreBookingTermsState() {
            // Booking terms теперь в настройках, а не в основном интерфейсе
            const section = document.getElementById('booking-terms-section');
            if (!section) {
                // Элемент не существует (удалён), просто возвращаемся
                return;
            }

            const content = section.querySelector('.collapsible-content');
            const inner = section.querySelector('.collapsible-content-inner');
            const textarea = document.getElementById('booking-terms');
            const savedState = localStorage.getItem('quoteCalc_bookingTermsExpanded');

            // Инициализируем высоту textarea
            if (textarea && textarea.value) {
                textarea.style.height = 'auto';
                textarea.style.height = textarea.scrollHeight + 'px';
            }

            // По умолчанию свернут
            if (savedState === 'true') {
                section.classList.add('expanded');
                // Устанавливаем динамическую высоту
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            }
        },

        updateCollapsibleHeight(textareaId) {
            // Автоматически изменяем размер textarea
            const textarea = document.getElementById(textareaId);
            textarea.style.height = 'auto'; // Сбрасываем высоту для корректного расчета
            textarea.style.height = textarea.scrollHeight + 'px'; // Устанавливаем новую высоту

            // Определяем какую секцию обновлять
            const sectionId = textareaId === 'quote-description' ? 'quote-comments-section' : 'program-description-section';
            const section = document.getElementById(sectionId);

            // Обновляем высоту коллапсируемой секции только если она развернута
            if (section.classList.contains('expanded')) {
                const content = section.querySelector('.collapsible-content');
                const inner = section.querySelector('.collapsible-content-inner');
                const height = inner.scrollHeight;
                content.style.maxHeight = height + 'px';
            }
        }
    });
}
